import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["contentType", "contentSection", "typeOption"];

  connect() {
    this.toggleContentSections(this.selectedContentType);
  }

  select(event) {
    const selectedType = event.target.value;

    this.toggleContentSections(selectedType);
    this.highlightSelectedOption(selectedType);
  }

  toggleContentSections(type) {
    this.contentSectionTargets.forEach((section) => {
      if (section.dataset.contentType === type) {
        section.classList.remove("hidden");
      } else {
        section.classList.add("hidden");
      }
    });
  }

  highlightSelectedOption(type) {
    this.typeOptionTargets.forEach((option) => {
      if (option.dataset.contentType === type) {
        option.classList.add("border-indigo-500", "ring-2", "ring-indigo-500");
      } else {
        option.classList.remove(
          "border-indigo-500",
          "ring-2",
          "ring-indigo-500"
        );
      }
    });
  }

  get selectedContentType() {
    const selectedRadio = this.contentTypeTargets.find(
      (radio) => radio.checked
    );
    return selectedRadio ? selectedRadio.value : "text";
  }
}
